import { produce } from 'immer';

const reducer = produce((draft, action) => {
    switch (action.type) {
        case navActions.toggleCollapse: {
            draft.collapsed = !draft.collapsed;
            break;
        }
        case navActions.openSubNav: {
            draft.openedNav = action.payload;
            break;
        }
        case navActions.closeSubNav: {
            draft.openedNav = undefined;
            break;
        }
        case navActions.setHoverTimeout: {
            if (action.payload === undefined && draft.hoverTimeOut)
                clearTimeout(draft.hoverTimeOut);
            draft.hoverTimeOut = action.payload;
            break;
        }
    }
});
var navActions;
(function (navActions) {
    navActions["toggleCollapse"] = "toggleCollapse";
    navActions["openSubNav"] = "openSubNav";
    navActions["closeSubNav"] = "closeSubNav";
    navActions["setHoverTimeout"] = "setHoverTimeout";
})(navActions || (navActions = {}));

export { navActions, reducer };
//# sourceMappingURL=reducer.esm.js.map
